import { apiClient } from "@/lib/api/client";
import type {
  WalletBalanceResponse,
  BusinessWalletBalanceResponse,
  BusinessWalletHistoryResponse,
  WalletHistoryResponse,
  WalletProcessPaymentPayload,
  WalletProcessPaymentResponse,
  WalletTopUpPayload,
  WalletTopUpResponse,
} from "@/features/wallet/types";

/**
 * Lexon balancen aktuale te wallet-it nga backend-i.
 */
export const getBalance = async (): Promise<WalletBalanceResponse> => {
  const response = await apiClient.get<WalletBalanceResponse>("/wallet/balance");
  return response.data;
};

/**
 * Lexon historikun e transaksioneve financiare.
 */
export const getHistory = async (): Promise<WalletHistoryResponse> => {
  const response = await apiClient.get<WalletHistoryResponse>("/wallet/history");
  return response.data;
};

export const getBusinessWalletBalance = async (businessId: number): Promise<BusinessWalletBalanceResponse> => {
  const response = await apiClient.get<BusinessWalletBalanceResponse>(`/businesses/${businessId}/wallet`);
  return response.data;
};

export const getBusinessWalletHistory = async (businessId: number): Promise<BusinessWalletHistoryResponse> => {
  const response = await apiClient.get<BusinessWalletHistoryResponse>(`/businesses/${businessId}/wallet/history`);
  return response.data;
};

export const topUpBusinessWallet = async (businessId: number, payload: WalletTopUpPayload): Promise<WalletTopUpResponse> => {
  const response = await apiClient.post<WalletTopUpResponse>(`/businesses/${businessId}/wallet/topup`, payload);
  return response.data;
};

/**
 * Kryen top-up simulues dhe kthen gjendjen e re nga backend-i.
 */
export const topUp = async (payload: WalletTopUpPayload): Promise<WalletTopUpResponse> => {
  const response = await apiClient.post<WalletTopUpResponse>("/wallet/topup", payload);
  return response.data;
};

/**
 * Verifikon nese nje invoice_id ekziston ne DB para pageses.
 * Kthe 404 nese nuk gjendet — blloku i sigurise frontend.
 */
export const verifyInvoice = async (referenceId: string): Promise<{ found: boolean; amount: string; status: string; currency: string }> => {
  const response = await apiClient.get(`/wallet/verify-invoice/${encodeURIComponent(referenceId)}`);
  return response.data as { found: boolean; amount: string; status: string; currency: string };
};

/**
 * Kryen debit real ne wallet per nje reference funksionale.
 */
export const processPayment = async (
  payload: WalletProcessPaymentPayload,
): Promise<WalletProcessPaymentResponse> => {
  const response = await apiClient.post<WalletProcessPaymentResponse>("/wallet/process-payment", payload);
  return response.data;
};

/**
 * Shkarkon PDF-in e faturës sipas referencës (ref_type + ref_id nga transaksioni).
 * Kthon Blob → krijon link të përkohshëm → klikon → anulon URL.
 */
export const downloadInvoicePdf = async (
  refType:  string,
  refId:    string,
  filename: string = "Fatura-EShendetesia.pdf",
): Promise<void> => {
  const response = await apiClient.get("/wallet/invoice-pdf", {
    params:       { ref_type: refType, ref_id: refId },
    responseType: "blob",
  });
  const blob = new Blob([response.data as BlobPart], { type: "application/pdf" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
